// The club this device last signed in to. PIN login sends it so a 4-digit
// PIN is only looked up inside that club (two clubs may use the same PIN).
// It survives logout; only the session is cleared.
const KEY = 'rentos_device_club';
const KEEP = [KEY, 'rentos-pos-ui'];

export const deviceClub = () => {
  try { return localStorage.getItem(KEY) || undefined; } catch { return undefined; }
};

export const rememberClub = clubId => {
  try { if (clubId) localStorage.setItem(KEY, clubId); } catch { /* storage unavailable */ }
};

export const clearSession = () => {
  try {
    const kept = KEEP.map(key => [key, localStorage.getItem(key)]);
    localStorage.clear();
    kept.forEach(([key, value]) => { if (value) localStorage.setItem(key, value); });
  } catch { /* storage unavailable */ }
};
